import {remCalc} from '_themeUtils'
import {tabsAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(tabsAnatomy.keys)

const baseStyle = definePartsStyle({
    tab: {
        textTransform: 'uppercase',
        letterSpacing: remCalc(3),
    },
})

const sizes = {
    sm: definePartsStyle({
        tablist: {
            textStyle: 'paragraphXs',
        },
        tab: {
            fontSize: 'inherit',
            px: 0,
            py: 'spacing.3',
        },
    }),
}

const variants = {
    line: definePartsStyle({
        tablist: {
            borderBottom: 0,
            gap: {base: 0, md: 'spacing.6'},
            pb: remCalc(2),
            justify: {base: 'space-evenly', md: 'flex-start'},
        },
        tab: {
            textStyle: 'paragraphXs',
            color: 'color.text.tab.default',
            borderBottom: `${remCalc(2)} solid`,
            borderBottomColor: 'color.border.tab.default',
            flex: {base: 1, md: 'auto'},
            _selected: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
            _active: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
        },
        tabpanel: {
            p: 0,
        },
    }),
}

const tabs = {Tabs: defineMultiStyleConfig({baseStyle, sizes, variants})}

export default tabs
